import { FileDownloadConfirmService } from '../../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { GetImageFileUrlModel } from '../../kymw1400/vo/get-image-file-url.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 画像ファイルURLを取得する。
 *
 * @export
 * @class GetImageFileUrlService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetImageFileUrlService extends PlessJsonResponderSub<any> {

  private vo: GetImageFileUrlModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {GetImageFileUrlModel} vo
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof GetImageFileUrlService
   */
  execute(vo: GetImageFileUrlModel, fileDownloadConfirmService: FileDownloadConfirmService) {
    this.vo = vo;
    fileDownloadConfirmService.show(this.vo.imagePreviewPath, this.vo.imagePreviewName);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof GetImageFileUrlService
   */
  success(_: any) {
  }
}
